import React from 'react';
import { FaTwitter, FaPatreon, FaItchIo, FaCoffee  } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="relative w-full max-w-[100em] m-auto flex flex-col justify-center items-center bg-dark-blue text-gray-300 px-4 py-8 space-y-4 top-[65px] lg:top-[95px]">

      {/* Social Media Links */}
      <div className="flex space-x-4 mb-2">
        <a href="https://twitter.com/christina_kral" className="hover:text-gray-500">
          <FaTwitter size={24} color="#1DA1F2" />
        </a>
        <a href="https://www.patreon.com/Christinna" className="hover:text-gray-500">
          <FaPatreon size={24} color="#EFE4E3" />
        </a>
        <a href="https://christinak.itch.io/" className="hover:text-gray-500">
          <FaItchIo size={24} color="#FA5C5C" />
        </a>
        <a href="https://ko-fi.com/christinak" className="hover:text-gray-500">
          <FaCoffee size={24} color="#FF5F5F" /> {/* Use a color that represents Ko-fi */}
        </a>

      </div>

      {/* Copyright Information */}
      <div className="flex flex-wrap gap-4 justify-center items-center text-center text-sm px-3 py-2">
        <span className="w-full sm:w-auto">© 2025 Deck Hopper</span>
        <Link to="/license" className="w-full sm:w-auto hover:underline">License Information</Link>
        <Link to="/privacy-policy" className="w-full sm:w-auto hover:underline">Privacy Policy</Link>
        <Link to="/patch-notes" className="w-full sm:w-auto hover:underline">Patch Notes</Link>
      </div>
    </footer>
  );
};

export default Footer;
